import { isFeatureEnabled } from "../../data/Services/settings";

// Entries with a `feature` key are gated by settings.features.* (release
// flags — see settings.jsx). Read the list via getChartTypes() at USE time,
// never at module scope: runtime-config.json loads before the app renders
// but after modules evaluate, so a module-level filter would only ever see
// the compiled defaults.
const chartTypes = [
  { label: "Candle", value: "candle" },
  { label: "Barras", value: "bar" },
  { label: "Barras Coloridas", value: "colorbar" },
  { label: "Linha", value: "line" },
  { label: "Hollow Candle", value: "hollowcandle" },
  { label: "Montanha", value: "mountain" },
  { label: "Linha de base", value: "baseline" },
  { label: "Candle por Volume", value: "candlevolume" },
  { label: "Heikin Ashi", value: "heikinashi" },
  // { label: 'Kagi', value: 'kagi' },
  // { label: 'Line Break', value: 'linebreak' },
  { label: "Renko", value: "renko" },
  // { label: 'Range Bars', value: 'rangebars' },
  // P&F e Renko(chartiq) provados bit-compatible com o ChartIQ vivo (#82,
  // provas em tools/htmlchart-oracle/). P&F segue gated pela flag de release.
  {
    label: "Ponto & Figura",
    value: "pointfigure",
    feature: "pointAndFigure",
  },
];

export function getChartTypes() {
  return chartTypes.filter((ct) => !ct.feature || isFeatureEnabled(ct.feature));
}

export default chartTypes;
